import { EmptyState } from '@neshane/blueberry';

function LazyLoadError({
    icon = '⚠️',
    title = 'Unable to load',
    message = 'Something went wrong while loading this page',
    action = '🔄',
    actionText = 'Retry',
    retry
}) {
    return (
        <EmptyState
            icon={icon}
            title={title}
            message={message}
            action={action}
            actionText={actionText}
            onAction={retry}
        />
    );
}

export default LazyLoadError;
